import { useEffect, useState } from 'react';

/** Optional remote photo must never hold the application's startup barrier. */
export function TelegramAvatar({ photoUrl, name }: { photoUrl: string | null; name: string }) {
  const [loaded, setLoaded] = useState<string | null>(null);
  useEffect(() => {
    setLoaded(null);
    if (!photoUrl) return;
    let active = true;
    const image = new Image();
    image.referrerPolicy = 'no-referrer';
    image.onload = () => { if (active) setLoaded(photoUrl); };
    image.src = photoUrl;
    return () => { active = false; image.onload = null; };
  }, [photoUrl]);
  return <div className="profile-avatar" aria-hidden="true">
    {photoUrl && loaded === photoUrl
      ? <img key={photoUrl} src={photoUrl} alt="" referrerPolicy="no-referrer" onError={() => setLoaded(null)} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }} />
      : name.slice(0, 1).toUpperCase()}
  </div>;
}
